import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// App mono-langue « VBC Femenino » : espagnol uniquement.
// Les fichiers fr/en restent sur disque (locales/fr, locales/en) mais ne sont plus importés.
import es from './locales/es/translation.json';

// Corrige toute valeur de langue périmée (fr/en) issue d'une session précédente.
try { localStorage.setItem('language', 'es'); } catch (e) { /* localStorage indisponible */ }

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es }
    },
    lng: 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false // React gère déjà l'échappement
    },
    react: {
      useSuspense: false
    }
  });

// Mono-langue : changeLanguage force toujours 'es'.
export const changeLanguage = (lang) => {
  try { localStorage.setItem('language', 'es'); } catch (e) { /* noop */ }
  i18n.changeLanguage('es');
};

// La langue courante est toujours l'espagnol.
export const getCurrentLanguage = () => 'es';

export default i18n;
